import { useQuery } from '@tanstack/react-query';
import apiClient from 'api/client';

// ── Query keys ──────────────────────────────────────────────────────────────
export const reportKeys = {
  catalog: ['report-catalog'],
};

// ── Report catalog ───────────────────────────────────────────────────────────
export function useReportCatalog() {
  return useQuery({
    queryKey: reportKeys.catalog,
    queryFn: () => apiClient.get('/api/v1/reports/').then((r) => r.data),
    refetchInterval: (query) => {
      // Unlock state only moves when pipelines run, so poll faster only while a
      // report is still building its first transformation run.
      const data = query.state.data;
      const preparing = data?.reports?.some((rep) => rep.status === 'preparing');
      return preparing ? 15000 : 60000;
    },
  });
}
